/**
 * Country Situation API Service
 * Provides functions to fetch country situation data from pr_countries_situation table
 */

import { API_BASE_URL as API_BASE } from './apiConfig';

/**
 * Get country situation details
 * @param {string} countryName - Name of the country
 * @returns {Promise<Object>} Country situation data
 */
export const getCountrySituation = async (countryName) => {
  try {
    const response = await fetch(`${API_BASE}/api/country-situation/${encodeURIComponent(countryName)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching country situation:', error);
    throw error;
  }
};

/**
 * Get latest AI analysis for a country situation
 * @param {string} countryName
 */
export const getCountrySituationAI = async (countryName) => {
  try {
    const response = await fetch(`${API_BASE}/api/country-situation/${encodeURIComponent(countryName)}/ai`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching country situation AI:', error);
    throw error;
  }
};

const countrySituationApi = {
  getCountrySituation,
  getCountrySituationAI,
};

export default countrySituationApi;
